import React, { Component } from 'react';

// import TableWaterBalance from './table-water-balance/table-water-balance.component';
import ExportPDFTableWaterBalance from './table-water-balance/table-water-balance.component';
// ExportPDFTableWaterBalance
import './wrapper-table-water-balance.style.css';

export class WrapperTableWBL extends Component {
    constructor(props){
        super(props);
    }

    render() {
        return (
            <div className="wrapper-total">
                <h1 className="name-element-search-box">Water balance table</h1>
                <div className="container-tab-table-total">
                    {/* <TableWaterBalance dataNRWByDMA={this.props.dataNRWByDMA}></TableWaterBalance> */}
                    <ExportPDFTableWaterBalance dataNRWByDMA={this.props.dataNRWByDMA}></ExportPDFTableWaterBalance>
                </div>
            </div>
        )
    }
}

export default WrapperTableWBL
